import React from 'react'
import FaqItem from './FaqItem'
import SchemaMarkup from './SchemaMarkup'

const Faq = ({ title, description, faqData }) => {
  return (
    <section className='py-8 md:py-16'>
      {/* FAQPage Schema */}
      <SchemaMarkup
        type='FAQPage'
        data={{
          questions: faqData.map((faq) => ({
            question: faq.question,
            answer:
              typeof faq.answer === 'string'
                ? faq.answer.replace(/\n\n/g, ' ').replace(/\n/g, ' ')
                : `${faq.answer.intro} ${
                    faq.answer.bullets ? faq.answer.bullets.join(' ') : ''
                  }`,
          })),
        }}
      />

      <h2 className='text-xl md:text-3xl font-bold mb-4 text-text-primary text-center'>
        {title}
      </h2>
      <p className='text-text-secondary mb-12 max-w-2xl mx-auto text-center'>
        {description}
      </p>

      <div className='max-w-3xl mx-auto'>
        {faqData.map((faq, index) => (
          <FaqItem key={index} question={faq.question} answer={faq.answer} />
        ))}
      </div>
    </section>
  )
}

export default Faq
